import { z } from 'zod'

export const otpConfirmSchema = z.object({
  code: z
    .string()
    .length(6, 'settings:twoFactor.invalidCode')
    .regex(/^\d{6}$/, 'settings:twoFactor.invalidCode'),
})

export type OtpConfirmValues = z.infer<typeof otpConfirmSchema>

export const defaultOtpConfirmValues: OtpConfirmValues = { code: '' }

export type SetupStep = 'qr' | 'confirm'
